import { PropsWithChildren } from "react"
import { NarrowLayout } from "source/Layout"

export default function ConfirmationLayout({ children }: PropsWithChildren) {
  return (
    <NarrowLayout>
      <div className="login-form--narrow">{children}</div>
    </NarrowLayout>
  )
}
